import { AfterViewInit, Directive, Input } from '@angular/core';
import { LcsMultiSelectComponent } from '@lcs/shared/multi-select';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { RoleOption } from 'src/app/pages/role-register/models/role-option.interface';
import { RoleMultiSelectDataSource } from './role-multi-select-data-source';

@Directive({
    selector: 'lcs-multi-select[ndtRoleMultiSelect]',
    standalone: false
})
export class RoleMultiSelectDirective implements AfterViewInit {
   @Input() set accountId(accountId: number | null) {
      this._accountId = accountId;
      this.setDataSource();
   }

   get accountId(): number | null {
      return this._accountId;
   }

   @Input() set isOnSystemPage(isOnSystemPage: boolean) {
      this._isOnSystemPage = isOnSystemPage;
      this.setDataSource();
   }

   get isOnSystemPage(): boolean {
      return this._isOnSystemPage;
   }

   private _isOnSystemPage: boolean;

   private _accountId: number | null;

   constructor(private multiSelect: LcsMultiSelectComponent<RoleOption>, private store: Store<AppState>) {
      this.multiSelect.data = new RoleMultiSelectDataSource(this.store, []);
      this.multiSelect.displayWith = (item: RoleOption | null) => {
         return item ? `${item.name}` : null;
      };
   }

   ngAfterViewInit(): void {
      this.setDataSource();
   }

   private setDataSource() {
      let staticFilterOverride: string[] = [];
      if (this.isOnSystemPage) {
         staticFilterOverride = [`AccountId is null`];
      } else if (this.accountId) {
         staticFilterOverride = [`AccountId = ${this.accountId}`];
      }

      // This is being set twice because the lcs shared component we're using for some reason only checks the validity of the selectAll button's existence once
      this.multiSelect.data = new RoleMultiSelectDataSource(this.store, staticFilterOverride);
   }
}
